import React from "react";

export default function Terms() {
  return (
    <>
      <style>{`
        .doc-page {
          max-width: 900px;
          margin: 0 auto;
          padding: 40px 20px 80px;
          animation: fadeDoc 0.4s ease;
        }

        @keyframes fadeDoc {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }

        .doc-page h2 {
          font-size: 36px;
          margin-bottom: 10px;
        }

        .doc-page > p:first-of-type {
          font-size: 14px;
          opacity: 0.6;
          margin-bottom: 30px;
        }

        .doc-page p {
          font-size: 15px;
          line-height: 1.7;
          margin-bottom: 18px;
          opacity: 0.9;
        }

        .doc-page h3 {
          font-size: 20px;
          margin-top: 36px;
          margin-bottom: 10px;
          position: relative;
          padding-left: 12px;
        }

        .doc-page h3::before {
          content: "";
          position: absolute;
          left: 0;
          top: 6px;
          width: 4px;
          height: 16px;
          background: #22c55e;
          border-radius: 2px;
        }

        @media (max-width: 768px) {
          .doc-page h2 {
            font-size: 28px;
          }

          .doc-page h3 {
            font-size: 18px;
          }
        }
      `}</style>

      <div className="container doc-page">
        <h2>Terms of Service</h2>
        <p>Effective date: January 2026</p>

        <h3>1. Acceptance of Terms</h3>
        <p>
          By accessing or using the Sportyfo mobile application and related
          services (“Service”), you agree to be bound by these Terms of Service.
          If you do not agree to these Terms, you must not use the Service.
        </p>

        <h3>2. Eligibility and Age Requirement</h3>
        <p>
          Sportyfo is intended for users who are at least <strong>13 years
          old</strong>. By using the Service, you confirm that you meet this age
          requirement.
        </p>
        <p>
          If you are under the age of 18, you must have permission from a parent
          or legal guardian to use the Service. The parent or guardian is
          responsible for your use of the app.
        </p>

        <h3>3. Use of the Service</h3>
        <p>
          You agree to use Sportyfo only for lawful purposes and in compliance
          with these Terms. You are responsible for all activity that occurs
          under your account.
        </p>

        <h3>4. Account Registration and Security</h3>
        <p>
          Certain features require an account. You are responsible for
          maintaining the confidentiality of your login credentials and for all
          activities performed under your account.
        </p>
        <p>
          We reserve the right to suspend or terminate accounts that violate
          these Terms or applicable laws.
        </p>

        <h3>5. Intellectual Property</h3>
        <p>
          All content, trademarks, logos, features, and functionality of
          Sportyfo are owned by Sportyfo or its licensors and are protected by
          intellectual property laws.
        </p>
        <p>
          You may not copy, modify, distribute, or create derivative works from
          any part of the Service without prior written permission.
        </p>

        <h3>6. Termination</h3>
        <p>
          We may suspend or terminate your access to the Service at any time if
          you violate these Terms or misuse the app.
        </p>

        <h3>7. Disclaimer</h3>
        <p>
          Sportyfo is provided on an “as is” and “as available” basis. We make no
          warranties regarding the availability, accuracy, or reliability of
          the Service.
        </p>

        <h3>8. Limitation of Liability</h3>
        <p>
          To the maximum extent permitted by law, Sportyfo shall not be liable
          for any indirect, incidental, consequential, or special damages
          arising out of or related to your use of the Service.
        </p>

        <h3>9. Changes to These Terms</h3>
        <p>
          We may update these Terms from time to time. Continued use of the
          Service after changes are posted constitutes acceptance of the
          updated Terms.
        </p>

        <h3>10. Contact Us</h3>
        <p>
          If you have any questions about these Terms, please contact us at{" "}
          <a href="mailto:sportyfo.official@gmail.com">
            sportyfo.official@gmail.com
          </a>.
        </p>
      </div>
    </>
  );
}
